
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customerservices",
      function () {
        return require("private-next-pages/customerservices/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customerservices"])
      });
    }
  